export class AddCirculars{
    circularsId?:number
    circularsTitle: string;
    circularsDescription: string;
    file: any;
    circularsTo: number[];
   public constructor (){
        this.circularsTo =[]
    }

}